import React, { useState } from 'react';

const CARD_VALUES = ['A', 'K', 'Q', 'J', 'T', '9', '8', '7', '6', '5', '4', '3', '2'];
const CARD_TYPES = ['d', 'c', 'h', 's'];

function CardSelector({ count = 2, value, onChange, label, usedCards = [], screen }) {
    const [currentCard, setCurrentCard] = useState(null);
    const [showValue, setShowValue] = useState(false);
    const [showType, setShowType] = useState(false);

    const isCardUsed = (val, type, cardNum) => {
        const cardStr = `${val}${type}`;
        const currentCardStr = `${value[`value${cardNum}`] || ''}${value[`type${cardNum}`] || ''}`;
        return usedCards.includes(cardStr) && cardStr !== currentCardStr;
    };

    const handleCardClick = (cardNum) => {
        for (let i = 1; i < cardNum; i++) {
            if (!value[`value${i}`] || !value[`type${i}`]) return;
        }
        setCurrentCard(cardNum);
        setShowValue(true);
        setShowType(false);
    };

    const handleValueSelect = (val) => {
        onChange({
            ...value,
            [`value${currentCard}`]: val
        });
        setShowValue(false);
        setShowType(true);
    };

    const handleTypeSelect = (type) => {
        const alreadySelected = value[`value${currentCard}`] && value[`type${currentCard}`];
        onChange({
            ...value,
            [`type${currentCard}`]: type
        });
        if (alreadySelected) {
            setCurrentCard(null);
            setShowValue(false);
            setShowType(false);
        } else {
            const next = currentCard < count ? currentCard + 1 : null;
            setCurrentCard(next);
            setShowValue(!!next);
            setShowType(false);
        }
    };

    const nextCardValue = value[`value${currentCard}`];
    const disabledTypes = CARD_TYPES.filter(type =>
        isCardUsed(nextCardValue, type, currentCard)
    );

    return (
        <div className="flex flex-col justify-center">
            {label &&
                <label className={`block mb-2 ${screen ? 'text-center' : ''}`}>{label}</label>
            }
            <div className={`flex ${screen ? 'justify-center' : ''}`} >
                {Array.from({ length: count }, (_, i) => (
                    <div
                        key={i + 1}
                        className="flex flex-col items-center mr-2 cursor-pointer"
                        onClick={() => handleCardClick(i + 1)}
                    >
                        <div className="w-12 h-16 bg-white rounded-lg text-black flex items-center flex-col justify-center text-lg font-bold ">
                            <span className='pt-1'>{value[`value${i + 1}`] || ''}</span>
                            <span className={`card-img ${value[`type${i + 1}`]}`}></span>
                        </div>
                    </div>
                ))}
            </div>
            {(showValue || showType) &&
                <div className={`relative ${screen ? 'mx-auto' : ''} ${showValue ? 'w-[234px]' : 'w-[278px] pl-[47px]'}`}>
                    {showValue && (
                        <div className="flex flex-wrap justify-start gap-2 mt-4 max-w-[270px] w-full">
                            <div className='flex flex-wrap justify-center gap-2'>
                                {CARD_VALUES.map(val => {
                                    const allTypesUsed = CARD_TYPES.every(type => isCardUsed(val, type, currentCard));
                                    return (
                                        <button
                                            type="button"
                                            key={val}
                                            className={`w-10 h-10 bg-white border text-black rounded-lg flex items-center justify-center text-lg font-bold hover:bg-primary hover:border-white hover:text-white ${allTypesUsed ? 'opacity-50 cursor-not-allowed' : ''}`}
                                            onClick={() => !allTypesUsed && handleValueSelect(val)}
                                            disabled={allTypesUsed}
                                        >
                                            {val}
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                    {showType && (
                        <div className="flex flex-wrap justify-start gap-2 mt-4 max-w-[270px] w-full">
                            {CARD_TYPES.map(type => {
                                const isDisabled = disabledTypes.includes(type);
                                return (
                                    <button
                                        type="button"
                                        key={type}
                                        disabled={isDisabled}
                                        className={`w-10 h-10 rounded-lg flex items-center justify-center border-2 ${isDisabled ? 'bg-gray-600 border-gray-600 cursor-not-allowed' : 'hover:bg-gray-300 hover:border-gray-300 hover:text-white bg-white'}`}
                                        onClick={() => !isDisabled && handleTypeSelect(type)}
                                    >
                                        <span className={`card-img ${type}`}></span>
                                    </button>
                                );
                            })}
                        </div>
                    )}

                    {(showValue || showType) && (
                        <>
                            <button
                                type="button"
                                className="w-10 h-10 rounded-lg flex items-center justify-center border-2 border-red-600 bg-red-600 hover:bg-red-500 absolute bottom-0 left-0"
                                onClick={() => {
                                    setShowValue(false);
                                    setShowType(false);
                                    setCurrentCard(null);
                                }}
                            >
                                ←
                            </button>
                            <button
                                type="button"
                                className="w-10 h-10 rounded-lg flex items-center justify-center border-2 border-red-600 bg-red-600 hover:bg-red-500 absolute bottom-0 right-0"
                                onClick={() => {
                                    if (!currentCard) return;
                                    onChange({
                                        ...value,
                                        [`value${currentCard}`]: '',
                                        [`type${currentCard}`]: ''
                                    });
                                    setShowValue(false);
                                    setShowType(false);
                                    setCurrentCard(null);
                                }}
                            >
                                ✕
                            </button>
                        </>
                    )}
                </div>
            }
        </div>
    );
}

export default CardSelector;
